
<div class="editor-content">

  <!-- --------------------------------------------------------- TIÊU ĐỀ MỞ RỘNG --------------------------------------------------------- -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <!-- ----------------------------------------------------------- MENU CONFIG ----------------------------------------------------------- -->
  <ng-container *ngIf="!isViewAll">

    <app-position-out-config 
      [elementChoosing]="objectChoosing" 
      [device]="device" 
      [id_parent_choose]="objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
    </app-position-out-config>

    <app-width-height-config 
      [width]="class['menu__content']['width']"
      [device]="device" 
      [elementChoosing]="objectChoosing"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>

    <ul nz-menu nzMode="inline">
      <!-- ------------------------------------------------------------ HIỂN THỊ ------------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'hien_thi'| translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <app-hide-show-config
            [elementChoosing]="objectChoosing"
            [device]="device"
            [isBlock]="false">
          </app-hide-show-config>
        </div>
      </li>

      <!-- -------------------------------------------------------- TIÊU ĐỀ MENU LỚN --------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'tieu_de_menu_lon' | translate">
        <ul>
          <!-- ---------------------------------------------------------- ĐỊNH DẠNG CHỮ ---------------------------------------------------------- -->
          <li nz-submenu [nzTitle]="'dinh_dang_chu' | translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
            <!-- Nội dung -->
            <div class="config-text" style="width: 100%">
              <!-- chọn ngôn ngữ đa ngôn ngữ -->
              <div class="field-row mb-3">
                
              </div>
              <mat-form-field style="width: 100%">
                <mat-label>{{'noi_dung' | translate}}</mat-label>
                <textarea matInput 
                  [ngModel]="staticdata['parent_category_name_' + functionService.selectedLanguageCode] | vhLanguage : 'parent_category_name' : objectChoosing.component" 
                  (ngModelChange)="staticdata['parent_category_name_' + functionService.selectedLanguageCode] = $event" 
                  (blur)="updateStaticData()"></textarea>
              </mat-form-field>
            </div>

            <app-text-format-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [config]="config"
              
              [staticdata]="staticdata"
              [textContentClass]="class['menu__content']"
              [textWrapperClass]="class['menu__content']">
            </app-text-format-config>

            <!-- Khoảng cách chữ -->
            <app-letter-spacing-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [classLetterSpacing]="class['menu__content']">
            </app-letter-spacing-config>

            <!-- Khoảng cách dòng -->
            <app-line-height-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [classLineHeight]="class['menu__content']">
            </app-line-height-config>
          </li>

          <!-- ------------------------------------------------------------ ĐỊNH DẠNG ------------------------------------------------------------ -->
          <li nz-submenu [nzTitle]="'dinh_dang' | translate" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
            <!-- Khoảng cách danh mục cha và con -->
            <div class="config-name">
              <p>{{'khoang_cach_danh_muc_cha_va_con' | translate}}</p>
              <nz-input-number [nzMin]="0" [nzMax]="200" [nzStep]="1" 
                [ngModel]="class['menu__item']['margin-top'] | vhnumber" 
                (ngModelChange)="class['menu__item']['margin-top'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="200" [nzStep]="1" 
              [ngModel]="class['menu__item']['margin-top'] | vhnumber"
              (ngModelChange)="class['menu__item']['margin-top'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>

            <!-- Màu nền -->
            <div class="config-name">
              <p>{{'mau_nen' | translate}}</p>
              <div style="width:40%; max-width:40%">
                <input class="input-color w-100" type="button" 
                  [cpOKButton]="true" 
                  [style.background]="class['menu']['background-color']"
                  [(colorPicker)]="class['menu']['background-color']" 
                  (colorPickerClose)="updateClass()" />
              </div>
            </div>
          </li>

          <!-- ------------------------------------------------------------ KIỂU VIỀN ------------------------------------------------------------ -->
          <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
            <app-borders-config 
              [id_object]="objectChoosing._id"
              [isBlock]="false"
              [device]="device"
              [class]="class"
              [borderClass]="class['menu']">
            </app-borders-config>
            <!-- Nút mở rộng -->
            <div class="item-border my-3">
              <p class="m-0 my-2" (click)="openViewAll(styles_field[1])">{{'mo_rong' | translate}} &#8594;</p>
            </div>
          </li>
          
          <!-- ----------------------------------------------------------- BIỂU TƯỢNG ------------------------------------------------------------ -->
          <li nz-submenu [nzTitle]="'bieu_tuong' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
            <app-symbol-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [config]="config"
              [symbolClass]="class['menu']"
              [fontSizeIconClass]="class['menu__content--icon']"
              [symbolConfig]="config['flex-direction']">
            </app-symbol-config>
          </li>
        </ul>
      </li>

      <!-- -------------------------------------------------------- TIÊU ĐỀ MENU CHA --------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'tieu_de_menu_cha' | translate">
        <ul>
          <!-- ------------------------------------------------------------ SỐ LƯỢNG ------------------------------------------------------------- -->
          <li nz-submenu [nzTitle]="'so_luong' | translate" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
            <div class="config-name">
              <p>{{'so_luong' | translate}}</p>
              <nz-input-number [nzMin]="1" [nzMax]="100" 
                [(ngModel)]="config['showMenuParentNumber']"
                (nzBlur)="updateConfig(); vhEventMediator.notifyOnConfigChanged({ _id: this.objectChoosing._id, change_showMenuParentNumber: true })">
              </nz-input-number>
            </div>

            <!-- Độ rộng thanh cuộn -->
            <div>
              <div class="config-name">
                <p>{{'do_rong_thanh_cuon' | translate}}</p>
                <nz-input-number [nzMin]="1" [nzMax]="100"
                  [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                  (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div> 
              <div>
                <nz-slider [nzMin]="1" [nzMax]="100" 
                  [ngModel]="config['-webkit-scrollbar']['width'] | vhnumber"
                  (ngModelChange)="config['-webkit-scrollbar']['width'] = $event +'px'"
                  (nzOnAfterChange)="updateConfig()">
                </nz-slider>
              </div>
            </div>
            <!-- Bo góc thanh cuộn -->
            <div>
              <div class="config-name">
                <p>{{'bo_goc_thanh_cuon' | translate}}</p>
                <nz-input-number [nzMin]="1" [nzMax]="100"
                  [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                  (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'"
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div> 
              <div>
                <nz-slider [nzMin]="1" [nzMax]="100" 
                  [ngModel]="config['-webkit-scrollbar']['border-radius'] | vhnumber"
                  (ngModelChange)="config['-webkit-scrollbar']['border-radius'] = $event +'px'"
                  (nzOnAfterChange)="updateConfig()">
                </nz-slider>
              </div>
            </div>
            <!-- Màu nền thanh cuộn -->
            <div class="config-name mt-4">
              <p>{{'mau_nen_thanh_cuon' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [cpOKButton]="true" 
                  [style.background]="config['-webkit-scrollbar']['background-color']"
                  [(colorPicker)]="config['-webkit-scrollbar']['background-color']"
                  (colorPickerClose)="updateConfig()" />
              </div>
            </div>
            <!-- Màu thanh cuộn -->
            <div class="config-name mt-4">
              <p>{{'mau_thanh_keo' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [cpOKButton]="true" 
                  [style.background]="config['-webkit-scrollbar']['thumb-background-color']"
                  [(colorPicker)]="config['-webkit-scrollbar']['thumb-background-color']"
                  (colorPickerClose)="updateConfig()" />
              </div>
            </div>
          </li>

          <!-- ---------------------------------------------------------- ĐỊNH DẠNG CHỮ ---------------------------------------------------------- -->
          <li nz-submenu [nzTitle]="'dinh_dang_chu' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <app-text-format-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [config]="config"
              
              [staticdata]="staticdata"
              [textContentClass]="class['menu__item-category__link']"
              [textWrapperClass]="class['menu__item-category__link']">
            </app-text-format-config>

            <!-- Khoảng cách chữ -->
            <app-letter-spacing-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [classLetterSpacing]="class['menu__item-category__link']">
            </app-letter-spacing-config>

            <!-- Khoảng cách dòng -->
            <app-line-height-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [classLineHeight]="class['menu__item-category__link']">
            </app-line-height-config>

            <!-- Màu nền -->
            <div class="config-name mt-4">
              <p>{{'mau_thanh_keo' | translate}}</p>
              <div>
                <input class="input-color" type="button"
                  [cpOKButton]="true" 
                  [style.background]="class['menu__item-category__link']['background-color']"
                  [(colorPicker)]="class['menu__item-category__link']['background-color']"
                  (colorPickerClose)="updateClass()" />
              </div>
            </div>
          </li>

          <!-- ------------------------------------------------------------ KIỂU VIỀN ------------------------------------------------------------ -->
          <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
            <app-borders-config 
              [id_object]="objectChoosing._id"
              [device]="device"
              [class]="class"
              [borderClass]="class['menu__item-category__link']"
              [isBlock]="false">
            </app-borders-config>
            <!-- Nút mở rộng -->
            <div class="item-border my-3">
              <p class="m-0 my-2" (click)="openViewAll(styles_field[2])">{{'mo_rong' | translate}} &#8594;</p>
            </div>
          </li>

          <!-- ------------------------------------------------------------- BỘ ICON ------------------------------------------------------------- -->
          <li nz-submenu [nzTitle]="'bo_icon' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
            <button nz-button nz-dropdown [nzDropdownMenu]="menu" class="p-0 w-100 d-flex justify-content-center"
              [nzPlacement]="'bottomCenter'">
              <div style="font-size: 18px; display: flex; justify-content: space-around; align-items: center;">
                <i [class]="config.expand_icon" class="mr-2"></i>
                <i [class]="config.collapse_icon"></i>
              </div>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item *ngFor="let item of bootstrapIconArrows" (click)="onChangeIcons(item)">
                  <div class="p-0 w-100 d-flex justify-content-center ">
                    <i [class]="item.expand_icon" class="mr-2"></i>
                    <i [class]="item.collapse_icon"></i>
                  </div>
                </li>
              </ul>
            </nz-dropdown-menu>
          </li>
        </ul>
      </li>

      <!-- ------------------------------------------------------- TƯƠNG TÁC HIỂN THỊ -------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'tuong_tac_hien_thi' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
        <nz-select [(ngModel)]="config['display_type']" (ngModelChange)="updateConfig()">
          <nz-option nzValue="none" [nzLabel]="'luon_hien_thi' | translate"></nz-option>
          <nz-option nzValue="click" [nzLabel]="'khi_nhan' | translate"></nz-option>
        </nz-select>
      </li>

      <!-- ---------------------------------------------------------- HIỆU ỨNG MENU ---------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'hieu_ung_menu' | translate">
        <ul>
          <!-- ---------------------------------------------------------- Màu khi chạm ----------------------------------------------------------- -->
          <li *ngIf="device == 'desktop'" nz-submenu [nzTitle]="'mau_khi_cham' | translate" [(nzOpen)]="openMap.menu12" (nzOpenChange)="openHandler('menu12')">
            <!-- Màu chữ -->
            <div class="config-name">
              <p>{{'mau_chu' | translate}}</p>
              <div style="width:40%; max-width:40%">
                <input class="input-color w-100" type="button" 
                  [cpOKButton]="true" 
                  [style.background]="config.desktop_background_hover_menu_item.color"
                  [(colorPicker)]="config.desktop_background_hover_menu_item.color" 
                  (colorPickerClose)="updateConfig()" />
              </div>
            </div>

            <!-- Màu nền -->
            <div class="config-name">
              <p>{{'mau_nen' | translate}}</p>
              <div style="width:40%; max-width:40%">
                <input class="input-color w-100" type="button" 
                  [cpOKButton]="true" 
                  [style.background]="config.desktop_background_hover_menu_item.background_color"
                  [(colorPicker)]="config.desktop_background_hover_menu_item.background_color" 
                  (colorPickerClose)="updateConfig()" />
              </div>
            </div>

            <!-- Thời gian -->
            <div class="field-timeline">
              <div class="config-name mb-0">
                <p>{{'thoi_gian' | translate}} (s)</p>
                <nz-input-number [nzMin]="0" [nzStep]="0.1" [nzMax]="1"
                  [(ngModel)]="config.desktop_background_hover_menu_item.transition"
                  (nzBlur)="updateConfig()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0" [nzStep]="0.1" [nzMax]="1"
                [(ngModel)]="config.desktop_background_hover_menu_item.transition"
                (nzOnAfterChange)="updateConfig()">
              </nz-slider>
            </div>
          </li>

          <!-- ---------------------------------------------------------- Màu khi chọn ----------------------------------------------------------- -->
          <li nz-submenu [nzTitle]="'mau_khi_chon' | translate" [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
            <!-- Màu chữ -->
            <div class="config-name">
              <p>{{'mau_chu' | translate}}</p>
              <div style="width:40%; max-width:40%">
                <input class="input-color w-100" type="button" 
                  [cpOKButton]="true" 
                  [style.background]="config.desktop_background_active_menu_item.color"
                  [(colorPicker)]="config.desktop_background_active_menu_item.color" 
                  (colorPickerClose)="updateConfig()" />
              </div>
            </div>

            <!-- Màu nền -->
            <div class="config-name">
              <p>{{'mau_nen' | translate}}</p>
              <div style="width:40%; max-width:40%">
                <input class="input-color w-100" type="button" 
                  [cpOKButton]="true" 
                  [style.background]="config.desktop_background_active_menu_item.background_color"
                  [(colorPicker)]="config.desktop_background_active_menu_item.background_color" 
                  (colorPickerClose)="updateConfig()" />
              </div>
            </div>
          </li>
        </ul>
      </li>

      <!-- ---------------------------------------------------------- THÊM LIÊN KẾT ---------------------------------------------------------- -->
      <li nz-submenu [nzTitle]="'them_lien_ket' | translate" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
        <app-link-page-config 
          [id_object]="objectChoosing._id"
          [type_page]="['detail_category']" 
          [staticdata]="staticdata" >
        </app-link-page-config>
      </li>
    </ul>
  </ng-container>


  <!-- -------------------------------------------------------- CẤU HÌNH CHI TIẾT -------------------------------------------------------- -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config
        [id_object]="objectChoosing._id"
        [device]="device"
        [class]="class"
        [borderRadiusClass]="class['menu']">
      </app-borders-radius-config>
    </div>

    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config
        [id_object]="objectChoosing._id"
        [device]="device"
        [class]="class"
        [borderRadiusClass]="class['menu__item-category__link']">
      </app-borders-radius-config>
    </div>
  </div>

</div>
